import { lazy, Suspense } from 'react'
import './App.css'
import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/queryClient'
// 1. Import Toaster
import { Toaster } from 'react-hot-toast';
import { EnvIndicator } from '@/components/common/EnvIndicator';
import { TimeOverrideLauncher } from '@/components/portal/common/time-override/TimeOverrideLauncher';

const enableDevtools =
  import.meta.env.DEV || import.meta.env.VITE_ENABLE_DEVTOOLS === 'true'

const ReactQueryDevtools = enableDevtools
  ? lazy(() =>
      import('@tanstack/react-query-devtools').then((m) => ({
        default: m.ReactQueryDevtools,
      }))
    )
  : null

function App() {
  return (
      <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />

          <EnvIndicator />
          <TimeOverrideLauncher />

          {/* 2. Add Toaster here with position setting */}
          <Toaster 
             position="bottom-right" 
             toastOptions={{
                 // Optional: Customizing styles to match your theme
                 style: {
                   background: '#ffffff',
                   color: '#05004E',
                   fontSize: '14px',
                   fontFamily: 'Inter',
                   fontWeight: '500',
                 },
             }}
          />
          
          {ReactQueryDevtools && (
            <Suspense fallback={null}>
              <ReactQueryDevtools initialIsOpen={false} />
            </Suspense>
          )}
      </QueryClientProvider>
  )
}

export default App